<script>
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import DynamicComponentActionElement
  from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import { useStoryCommentsStore } from "%/dynamic-component-editor/stores/story-comments-store";
import { BUBBLE_OPENS_OVERLAY, bubbleTapOutcome } from "%/dynamic-component-editor/helpers/story-comments.mjs";
import { openStoryCommentsOverlay } from "%/dynamic-component-editor/components/story-comments/mount-story-comments-overlay";

export default {
  name: "CommentAction",
  actionLabel: "Comment",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayName: "Comment Action",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin],
  inject: {
    inFeedRow: { default: false },
  },
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.comment }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canCommentOnPosts",
    ]),
    shouldShowAction() {
      return this.editMode || this.canCommentOnPosts;
    },
    myValue() {
      return this.getOptionValue(DisplayValue) === "hide" ? "" : this.entity.commentCount;
    },
  },
  methods: {
    handleClick() {
      if (this.editMode) {
        return;
      }
      const storyId = Number(this.entity.id);
      if (bubbleTapOutcome({ inFeedRow: this.inFeedRow }) === BUBBLE_OPENS_OVERLAY) {
        openStoryCommentsOverlay(storyId, this.$.appContext);
        return;
      }
      if (useStoryCommentsStore().openCommentInputOnPage(storyId)) {
        return;
      }
      window.location.href = `${this.links.web}/story/${this.entity.id}?comment=true`;
    },
  },
};
</script>
